import { PieChart as CommonPieChart } from '../../../common/inventory/components/PieChart';
import { t } from 'i18next';
import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { PieChartSummary } from './PieChartSummary';
import { ReportDiffCountMap } from '../models/ReportDiffCountMap';
import { SEVERITY_COLORS, Severity } from '../../../common/enums/Severity';

type Props = {
  currentCountMap: ReportDiffCountMap;
  selectedCountMap: ReportDiffCountMap;
  type: 'issues' | 'instances';
};

export const PieChart = (props: Props) => {
  const { selectedCountMap, currentCountMap, type } = props;
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const chartData = [
    { name: t('high'), amount: currentCountMap.getHigh(), color: SEVERITY_COLORS[Severity.HIGH].main },
    { name: t('medium'), amount: currentCountMap.getMedium(), color: SEVERITY_COLORS[Severity.MED].main },
    { name: t('low'), amount: currentCountMap.getLow(), color: SEVERITY_COLORS[Severity.LOW].main },
    { name: t('passed'), amount: currentCountMap.getPassed(), color: SEVERITY_COLORS[Severity.PASSED].main },
    { name: t('blank'), amount: 0, color: SEVERITY_COLORS[Severity.NO_WARNING].main },
  ];

  if (currentCountMap.getTotal() === 0) {
    chartData[chartData.length - 1].amount = 1;
  }
  return (
    <Stack direction="row" alignItems="center">
      <Box sx={{ mt: 2, p: 2 }}>
        <CommonPieChart
          title={type === 'issues' ? t('a11y.comparison.issuesChart') : t('a11y.comparison.instancesChart')}
          data={chartData}
          radius={90}
          chartWidth={30}
          onMouseEnter={(index) => setActiveIndex(index)}
          onMouseLeave={() => setActiveIndex(null)}
          activeIndex={activeIndex ?? undefined}
          total={currentCountMap.getTotal() === 0 ? 0 : null}
        />
      </Box>
      <PieChartSummary
        type={type}
        currentCountMap={currentCountMap}
        selectedCountMap={selectedCountMap}
        activeIndex={activeIndex}
        onActiveIndexChange={(index) => setActiveIndex(index)}
      />
    </Stack>
  );
};
